import { render } from "./AfricaView.vue?vue&type=template&id=492cc5e4"
import script from "./AfricaView.vue?vue&type=script&lang=js"
export * from "./AfricaView.vue?vue&type=script&lang=js"

import "./AfricaView.vue?vue&type=style&index=0&id=492cc5e4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__